import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ma-4" },
    [
      _c(
        VExpansionPanels,
        {
          model: {
            value: _vm.panel,
            callback: function ($$v) {
              _vm.panel = $$v
            },
            expression: "panel",
          },
        },
        [
          _c(
            VExpansionPanel,
            [
              _c(VExpansionPanelHeader, [_vm._v("Parameters")]),
              _c(
                VExpansionPanelContent,
                [
                  _c("page-params", {
                    attrs: {
                      pageName: "flowControl",
                      vuexName: "flowControlParameters",
                      parameters: _vm.parameters,
                    },
                    on: { onLoad: _vm.loadedSavedParams },
                  }),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-space-around" },
                    [
                      _c("date-picker", {
                        staticClass: "mx-2",
                        attrs: {
                          outlined: "",
                          dense: "",
                          label: _vm.$vuetify.lang.t("$vuetify.base.startDate"),
                          defaultNowOnNull: false,
                          "show-hint": false,
                          "show-icon": false,
                        },
                        model: {
                          value: _vm.startDate,
                          callback: function ($$v) {
                            _vm.startDate = $$v
                          },
                          expression: "startDate",
                        },
                      }),
                      _c("date-picker", {
                        staticClass: "mx-2",
                        attrs: {
                          outlined: "",
                          dense: "",
                          label: _vm.$vuetify.lang.t("$vuetify.base.endDate"),
                          defaultNowOnNull: false,
                          "show-hint": false,
                          "show-icon": false,
                        },
                        model: {
                          value: _vm.endDate,
                          callback: function ($$v) {
                            _vm.endDate = $$v
                          },
                          expression: "endDate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("product-select", {
                    attrs: {
                      label: "Search Products",
                      multiple: "",
                      "return-object": "",
                    },
                    on: { onLoad: _vm.initProductList },
                    model: {
                      value: _vm.parameters.selectedProducts,
                      callback: function ($$v) {
                        _vm.$set(_vm.parameters, "selectedProducts", $$v)
                      },
                      expression: "parameters.selectedProducts",
                    },
                  }),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-center my-4" },
                    [
                      _c(
                        VBtn,
                        {
                          attrs: { color: "primary", loading: _vm.loading },
                          on: { click: _vm.onSubmit },
                        },
                        [_vm._v(" Submit ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(VDivider, { staticClass: "my-4" }),
      _vm.loaded
        ? _c(
            "div",
            { staticStyle: { position: "relative" } },
            [
              _vm.rows && _vm.rows.length > 0
                ? _c(
                    "div",
                    { staticClass: "menu d-flex justify-space-between" },
                    [
                      _c(
                        "div",
                        [
                          _c(VTextField, {
                            attrs: {
                              label: "Filter Products",
                              outlined: "",
                              dense: "",
                              "prepend-icon": "mdi-magnify",
                              clearable: "",
                            },
                            model: {
                              value: _vm.filterProductName,
                              callback: function ($$v) {
                                _vm.filterProductName = $$v
                              },
                              expression: "filterProductName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(VSlider, {
                        staticClass: "mx-6",
                        attrs: {
                          min: 8,
                          max: 16,
                          "append-icon": "mdi-magnify-plus-outline",
                          "prepend-icon": "mdi-magnify-minus-outline",
                          "thumb-label": "",
                        },
                        on: {
                          "click:append": _vm.zoomIn,
                          "click:prepend": _vm.zoomOut,
                        },
                        model: {
                          value: _vm.zoom,
                          callback: function ($$v) {
                            _vm.zoom = $$v
                          },
                          expression: "zoom",
                        },
                      }),
                      _c(
                        "div",
                        [
                          _c(
                            VBtnToggle,
                            {
                              attrs: { dense: "", multiple: "" },
                              model: {
                                value: _vm.displayRows,
                                callback: function ($$v) {
                                  _vm.displayRows = $$v
                                },
                                expression: "displayRows",
                              },
                            },
                            [
                              _c(
                                VBtn,
                                { attrs: { value: "delivery" } },
                                [_c(VIcon, [_vm._v("mdi-truck-delivery")])],
                                1
                              ),
                              _c(
                                VBtn,
                                { attrs: { value: "production" } },
                                [
                                  _c(VIcon, [
                                    _vm._v("mdi-account-hard-hat"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.rows && _vm.rows.length > 0
                ? _c("VueDjGantt", {
                    attrs: {
                      from: _vm.startDate,
                      to: _vm.endDate,
                      list: _vm.list,
                      rows: _vm.filteredRows,
                      items: _vm.filteredItems,
                      locale: "en",
                      height: _vm.viewportHeight - 300,
                      zoomLevel: _vm.zoom,
                    },
                    on: {
                      row: _vm.selectedRow,
                      cell: _vm.selectedCell,
                      "dblclick-cell": _vm.doubleClickedCell,
                      "dblclick-item": _vm.doubleClickedItem,
                      "time-slot": _vm.selectedTimeSlot,
                      zoom: _vm.zoomChanged,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "item-label",
                          fn: function (item) {
                            return [
                              item.item.type == "balance"
                                ? _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("formatNumber")(
                                            parseFloat(item.item.balance)
                                          )
                                        ) +
                                        " " +
                                        _vm._s(
                                          item.item.product.measureWeight
                                        ) +
                                        " "
                                    ),
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("formatNumber")(
                                            item.item.quantity
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]),
                            ]
                          },
                        },
                        {
                          key: "row-label",
                          fn: function (item) {
                            return [
                              item.row.type == "balance"
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-space-between",
                                    },
                                    [
                                      _c(
                                        VIcon,
                                        { staticClass: "my-auto mr-2 bg-icon" },
                                        [_vm._v(" mdi-vector-difference ")]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex-grow-1 text-ellipsis",
                                        },
                                        [_vm._v(_vm._s(item.row.name))]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "mx-2" },
                                        [
                                          _c("row-support-menu", {
                                            attrs: {
                                              rowItem: item,
                                              dateRange: _vm.dateRange,
                                            },
                                            on: {
                                              "open-dialog": _vm.openMenuDialog,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-space-between",
                                    },
                                    [
                                      _c(
                                        VIcon,
                                        { staticClass: "my-auto mr-2 bg-icon" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                item.row.type == "delivery"
                                                  ? "mdi-truck-delivery"
                                                  : "mdi-account-hard-hat"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex-grow-1 text-ellipsis ml-4",
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(item.row.name) + " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3104225476
                    ),
                  })
                : _c("div", { staticClass: "text-center font-weight-light" }, [
                    _vm._v("No data found"),
                  ]),
              _c(
                VOverlay,
                { attrs: { value: _vm.loading, absolute: "" } },
                [_c(VProgressCircular, { attrs: { indeterminate: "" } })],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        VDialog,
        {
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            VCard,
            [
              _c(
                VCardTitle,
                { staticClass: "justify-end" },
                [
                  _c(
                    VBtn,
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialog = false
                        },
                      },
                    },
                    [_c(VIcon, [_vm._v(" mdi-close ")])],
                    1
                  ),
                ],
                1
              ),
              _c(
                VCardText,
                [
                  _vm.dialogMode == "debug"
                    ? _c("pre", [_vm._v(" " + _vm._s(_vm.dialogContent) + " ")])
                    : _c(
                        _vm.dialogMode,
                        _vm._b(
                          {
                            tag: "component",
                            on: {
                              "on-success": _vm.onDialogSuccess,
                              "on-close": _vm.onDialogClose,
                            },
                          },
                          "component",
                          _vm.dialogData,
                          false
                        )
                      ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }